<template>
  <v-container fluid>
    <v-data-table :headers="headers" :items="referals" :items-per-page="15">
      <template v-slot:item.loginDateCreated="{ item }">
        {{ new Date(item.loginDateCreated).toLocaleDateString() }}
      </template>
      <template v-slot:item.paymentSum="{ item }">
        {{ item.paymentSum != null ? $options.filters.toCurrency(item.paymentSum) : "—" }}
      </template>
      <template v-slot:item.accruedTotal="{ item }">{{ item.accruedTotal | toCurrency }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "PartnerPharmacies",
  data: () => ({
    referals: [],
    headers: [
      { text: "Логин", value: "login" },
      { text: "Имя", value: "firstName" },
      { text: "Фамилия", value: "lastName" },
      { text: "Аптека", value: "pharmacyName" },
      { text: "Компания", value: "companyName" },
      { text: "Дата создания логина", value: "loginDateCreated" },
      { text: "Внесённая сумма", value: "paymentSum" },
      { text: "Начислено мне", value: "accruedTotal" },
    ],
  }),
  async created() {
    this.referals = await this.$store.dispatch("GET_PARTNER_REFERALS");
  },
};
</script>
